import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileEventsConfig } from '@v2/pages/job/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const JobDetailsNCFileEventsStack = createStackNavigator();

const JobDetailsNCFileEventsNavigator = (props: any) => {
  return (
    <JobDetailsNCFileEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileEventsConfig.map(({ Component, name }) => (
        <JobDetailsNCFileEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </JobDetailsNCFileEventsStack.Navigator>
  );
};

export { JobDetailsNCFileEventsNavigator };
